import loader from "./loader.gif";
import "./loader.css";

const Loader = ({msg="Loading...",w=""}) => {
  return (
    <div className="loader-contentV1">
      <div className={w?"loader1":"loader"} >
        <div className="loading"></div>
        <h5>{msg}</h5>
      </div>
    </div>
  );
};

export default Loader;
